import { useEffect } from 'react'
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import useLocalUserType from 'utils/useLocalUserType'

const useUserLeapAttributes = user => {
  const sendDataToGTM = useGTMDispatch()
  const [userType] = useLocalUserType()

  useEffect(() => {
    user
      ? sendDataToGTM({
          'User-Id': user.id,
          'User-Tenure': user.tenure,
          'User-Plan-Type': user.planType,
          'User-Grade-Level': user.gradeLevel,
          'User-Audience-Category': user.category ?? userType,
          'User-Status': user.subscriberStatus || 'Visitor',
          'User-Subscription-Date': user.subscriptionActivatedAt,
        })
      : sendDataToGTM({
          'User-Status': 'Visitor',
          'User-Audience-Category': userType,
        })
  }, [user && user.id, user && user.status, userType]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useUserLeapAttributes
